import {Rows} from "Components/Layout/Table";

const ProductGroupTable: Rows = {
    id: {
        placeholders: [
            {
                element: 'p',
                size: 1
            }
        ]
    },
    name: {
        translated: true,
        placeholders: [
            {
                element: 'p',
                size: [3, 1],
            }
        ]
    },
    actions: {
        className: 'actions',
        sortable: false,
        placeholders: [
            {
                element: 'a',
                size: 2,
            },
        ]
    },
};

export default ProductGroupTable